<template>
  <div ref="playerContainer" :id="id" class="xgplayer-container"></div>
</template>

<script>
import Player from 'xgplayer'
import 'xgplayer/dist/index.min.css'
export default {
  name: 'XGPlayer',
  props: {
    url: {
      type: String,
      required: true
    },
    controls: {
      type: Boolean,
      default: true
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    poster: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      player: null,
      id:
        'video-' +
        Math.random()
          .toString(36)
          .slice(2, 8)
    }
  },
  watch: {
    url: {
      handler(val) {
        this.$nextTick(() => {
          this.initPlayer()
        })
      },
      immediate: true
    }
  },
  mounted() {},
  beforeDestroy() {
    if (this.player) {
      this.player.destroy() // 销毁播放器实例
      this.player = null // 清空播放器引用
    }
  },
  methods: {
    initPlayer() {
      const config = {
        el: this.$refs.playerContainer,
        url: this.url,
        fluid: true,

        /**倍速播放 */
        playbackRate: [0.5, 0.75, 1, 1.5, 2],
        defaultPlaybackRate: 1,

        playsinline: this.isAppleDevice(), // IOS设备设置，防止被浏览器劫持
        'x5-video-player-type': 'h5', // 微信内置浏览器设置，防止被浏览器劫持
        'x5-video-orientation': 'portraint',
        /**画中画 */
        pip: true,
        pipConfig: {
          bottom: 100,
          right: 100,
          width: 320,
          height: 180
        },
        // download: true,
        /**初始化首帧 */
        videoInit: true,
        /**海报图 */
        poster: this.poster,
        /**自动播放 */
        autoplay: this.autoplay
      }
      const player = new Player(config)
      if (player) {
        this.player = player
        /* 这里注册监听 */
        // 监听视频开始播放 播放传给父组件的是true
        this.player.on('play', () => {
          this.$emit('triggerEvent', true)
        })
        // 监听视频已经暂停 暂停传给父组件的是true
        this.player.on('pause', () => {
          this.$emit('triggerEvent', false)
        })
        // 监听 视频退出全屏
        // this.player.on('exitFullscreen', () => {
        //   window.scrollTo(0, 0);
        //   console.log('已经退出全屏了');
        // });
      }
    },
    // IOS设备设置，防止被浏览器劫持
    isAppleDevice() {
      const ua = navigator.userAgent.toLowerCase()
      return /iphone|ipad|phone|Mac/i.test(ua)
    }
  }
}
</script>

<style scoped lang="scss">
.xgplayer-container {
  width: 100% !important;
  height: 100% !important;
  ::v-deep(video) {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
